import React from 'react';
import PropTypes from 'prop-types';
import API from "../../Api/Api";
import ImagesAPI from "../../Api/ImagesAPI";
import {
  Grid,
  Button,
  Card,
  CardHeader,
  CardMedia,
  CardActions,
  Tooltip
} from '@material-ui/core';

class ImageCard extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      imageURL: props.url,
      imageName: props.name,
      primaryKey: props.pk,
      cardActions: props.actions,
      allowDelete: props.allowDelete,
      api: props.api,
      display: props.display === false ? props.display : true, //this is done to get around falsy issues.
      cardStyle: props.cardStyle,
    }
  }

  /**
   * Deletes an image from the backend server using the primary key
   * stored in this component. 
   * On success, sets the state to not display itself.
   * On Failure, gives the user an alert and the status text from the response.
   */
  deleteImage() {
    this.state.api.deleteImage(this.state.primaryKey).then((response) => {
      this.setState({
        display: false,
      });
    }).catch((error) => {
      alert('Couldn\'t delete image: ' + error);
    });
  }

  /**
   * Maps the functions passed as a prop to buttons on the image card.
   */
  makeButtons() {
    if(!this.state.cardActions) {
      return null;
    }

    return (this.state.cardActions).map((cardAction) => {
      return (
        <Button size="small" color="primary" onClick={
          () => cardAction.action(
            this.state.imageURL,
            this.state.imageName,
            this.state.primaryKey,
          )
        }>
          {cardAction.label}
        </Button>
      );
    });
  }

  /**
   * Returns either the component to display or null based on if the state
   * is set to display.
   */
  getDisplay() {
    if(this.state.display) {
      return(
        <Grid item style={this.state.cardStyle}>
          <Tooltip title={this.state.imageName}>
            <Card>
              <CardHeader 
                title={this.state.imageName}
                titleTypographyProps={{style:{'font-size':'14px','overflowX':'hidden', 'width': '82%'}, noWrap:true}}
              />
              <CardMedia
              style={{
                height: 0,
                paddingTop: '56.25%',
              }}
              image={this.state.imageURL}
              title={this.state.imageName}
              />
              <CardActions>
                {this.makeButtons()}
                {this.state.allowDelete ? 
                  (<Button size="small" color="primary" onClick={() => {this.deleteImage()}}>
                    Delete
                  </Button>) : 
                  null
                }
                {/* todo add these as props for uploader<Button size="small" color="primary" onClick={() => {this.downloadImage()}}>
                  View
                </Button>
                <Button size="small" color="primary" onClick={() => {this.deleteImage()}}>
                  Delete
                </Button>*/}
              </CardActions>
            </Card>
          </Tooltip>
        </Grid>
      )
    }
    else {
      return null;
    }
  }

  render(){
    return(
      this.getDisplay()
    )
  }
}

ImageCard.propTypes = {
  imageURL: PropTypes.string.isRequired,
  imageName: PropTypes.string,
  pk: PropTypes.number.isRequired,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    action: PropTypes.func // receives (imageURL, imageName, pk)
  })),
  allowDelete: PropTypes.bool,
  display: PropTypes.bool,
  api: PropTypes.instanceOf(ImagesAPI),
  cardStyle: PropTypes.object, // Css style object
}

export default ImageCard;